import React from 'react';
import './Layout.css';
import logo from '../../assets/logo.jpg';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="layout">
      <header className="header">
        <div className="container">
          <a href="/">
            <img src={logo} alt="Acción Fiduciaria" className="logo" />
          </a>
        </div>
      </header>
      
      <main className="main-content">
        <div className="container">
          {children}
        </div>
      </main>
      
      <footer className="footer">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} Acción Fiduciaria. Todos los derechos reservados.</p>
        </div>
      </footer>
    </div>
  );
};

export default Layout; 